import { Route } from '@angular/router';
import { permissionGuard } from '../../../../../../core/guards/permission.guard';
import { UserPermissionEnum } from '../../../../../../core/models/user-permissions.enum';

export const DEVICE_CARD_CHILDREN: Route[] = [
  {
    path: 'management',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-management/device-management.component').then(
        (m) => m.DeviceManagementComponent,
      ),
  },
  {
    path: 'notifications',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-notification/device-notification.component').then(
        (m) => m.DeviceNotificationComponent,
      ),
  },
  {
    path: 'history',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.AuditRead },
    loadComponent: () =>
      import('./pages/device-history/device-history.component').then(
        (m) => m.DeviceHistoryComponent,
      ),
  },
  {
    path: 'hashrate',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-hashrate-chart/device-hashrate-chart.component').then(
        (m) => m.DeviceHashrateChartComponent,
      ),
  },
  {
    path: 'firmware',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-firmware/device-firmware.component').then(
        (m) => m.DeviceFirmwareComponent,
      ),
  },
  {
    path: 'timetable',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-timetable/device-timetable.component').then(
        (m) => m.DeviceTimetableComponent,
      ),
  },
  {
    path: 'schedule-journal',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.EquipmentRead },
    loadComponent: () =>
      import('./pages/device-schedule-journal/device-schedule-journal.component').then(
        (m) => m.DeviceScheduleJournalComponent,
      ),
  },
  {
    path: 'maintenance',
    canActivate: [permissionGuard],
    data: { requiredPermission: UserPermissionEnum.MaintenanceRead },
    loadComponent: () =>
      import('./pages/device-maintenance/device-maintenance.component').then(
        (m) => m.DeviceMaintenanceComponent,
      ),
  },
];
